import { Message } from 'element-ui'
import store from '@/store'

export const showTips = msg => {
  Message({
    message: msg,
    type: '',
    duration: 1500,
  })
}

export function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

export const tirmString = (str, char, type) => {
  // 清空字符串两边指定字符
  if (char) {
    if (type == 'left') {
      return str.replace(new RegExp('^\\' + char + '+', 'g'), '')
    } else if (type == 'right') {
      return str.replace(new RegExp('\\' + char + '+$', 'g'), '')
    }
    return str.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '')
  }
  return str.replace(/^\s+|\s+$/g, '')
}

export const scrollTop = (number = 0, time) => {
  if (!time) {
    document.body.scrollTop = document.documentElement.scrollTop = number
    return number
  }
  const spacingTime = 20 // 设置循环的间隔时间  值越小消耗性能越高
  let spacingInex = time / spacingTime // 计算循环的次数
  let nowTop = document.body.scrollTop + document.documentElement.scrollTop // 获取当前滚动条位置
  let everTop = (number - nowTop) / spacingInex // 计算每次滑动的距离
  let scrollTimer = setInterval(() => {
    if (spacingInex > 0) {
      spacingInex--
      scrollTop((nowTop += everTop))
    } else {
      clearInterval(scrollTimer) // 清除计时器
    }
  }, spacingTime)
}

/**
 * 阿拉伯数字转中文数字,
 * 如果传入数字时则最多处理到21位，超过21位js会自动将数字表示成科学计数法，导致精度丢失和处理出错
 * 传入数字字符串则没有限制
 * @param {number|string} digit
 */

export const numToChinese = num => {
  let str = ''
  switch (num) {
    case 1:
      str = '一'
      break
    case 2:
      str = '二'
      break
    case 3:
      str = '三'
      break
    case 4:
      str = '四'
      break
    case 5:
      str = '五'
      break
    case 6:
      str = '六'
      break
    case 7:
      str = '七'
      break
    case 8:
      str = '八'
      break
    case 9:
      str = '九'
      break
    case 10:
      str = '十'
      break
    case 11:
      str = '十一'
      break
    case 12:
      str = '十二'
      break
    case 13:
      str = '十三'
      break
    case 14:
      str = '十四'
      break
    case 15:
      str = '十五'
      break
    case 16:
      str = '十六'
      break
    case 17:
      str = '十七'
      break
    case 18:
      str = '十八'
      break
    case 19:
      str = '十九'
      break
    case 20:
      str = '二十'
      break
  }
  return str
}

/*
 * 设置显示更多的遮罩
 */

export const setMoreMask = (arr, V) => {
  arr.forEach(item => {
    // 用于控制显示/隐藏解析
    V.$set(item, 'isShow', false)
    V.$nextTick(() => {
      let el = document.getElementById(`question_${item.id}`)
      setTimeout(() => {
        if (el && el.offsetHeight > 300) {
          V.$set(item, 'isShowMore', true)
          V.$set(item, 'isMore', true)
        } else {
          V.$set(item, 'isShowMore', false)
        }
      }, 200)
    })
  })
}

/*
 * 设置选项宽度
 */
export const setOptionsWidth = async (option, optsParentWidth) => {
  let arr = []
  for (let key in option) {
    let elem = document.getElementById('question-options-width')
    elem.innerHTML = `<span>${key}. </span><span>${option[key]}</span>`
    let w = Math.floor(document.getElementById('question-options-width').clientWidth)
    // 选项存在图片的情况
    if (option[key].indexOf('<img') > -1) {
      let img = document.getElementById('question-options-width').querySelectorAll('img')[0]
      let promise = new Promise(reslove => {
        img.onload = async function () {
          if (w < img.naturalWidth) {
            w = w + img.naturalWidth
          }
          reslove()
        }
      })
      await promise
      arr.push(w)
    } else {
      arr.push(w)
    }
  }
  // console.log(arr);
  let maxWidth = Math.max.apply(null, arr), // 返回最大的一个宽度
    averageWidth = Math.floor(optsParentWidth / 4), // 根据选项个数平均宽度
    halfWidth = Math.floor(optsParentWidth / 2) // 父元素宽度的一半
  if (maxWidth < averageWidth) {
    // 最大宽度小于平均宽度
    return {
      row: 1,
      width: averageWidth,
    }
  } else if (maxWidth >= averageWidth && maxWidth < halfWidth) {
    // 一行两个
    return {
      row: 2,
      width: halfWidth,
    }
  } else if (maxWidth >= halfWidth) {
    return {
      row: 3,
      width: optsParentWidth,
    }
  }
}

/*
 * 设置选项宽度
 */
export const getOptionsWidth = (arr, optsParentWidth, V) => {
  arr.forEach(async item => {
    let w = '',
      sub_w = '',
      w_arr = []
    for (let m = 0; m < item.options.length; m++) {
      w = await setOptionsWidth(item.options[m], optsParentWidth)
      w_arr.push(w)
    }
    V.$set(item, 'w_arr', w_arr)
    item.sub_questions.forEach(async item => {
      if (item.options.length > 0) {
        for (let n = 0; n < item.options.length; n++) {
          sub_w = await setOptionsWidth(item.options[n], optsParentWidth)
          V.$set(item, 'sub_width', sub_w)
        }
      }
    })
  })
}

/*
 * 根据不同浏览器提示快捷键
 */
export const findShortcutKey = () => {
  let userAgent = window.navigator.userAgent,
    win = 'Windows',
    mac = 'Macintosh',
    shortcutKey = 'Ctrl + J'
  if (userAgent.indexOf(mac) > -1) {
    if (userAgent.indexOf('QQBrowser') > -1) {
      shortcutKey = 'Command + Shift + J'
    } else if (userAgent.indexOf('Safari') > -1) {
      shortcutKey = 'Command + Option + L'
    } else {
      shortcutKey = 'Command + J'
    }
    return shortcutKey
  } else if (userAgent.indexOf(win) > -1) {
    return shortcutKey
  } else {
    return shortcutKey
  }
}

/*
 * 401 to login
 */
export const locatioanToLogin = (err) => {
  if (err.code == 401) {
    let url = encodeURIComponent(window.location.href)
    window.location.href = `${store.state.baseLink}login?redirect=${url}`
  }
}

export const isMobile = ua => {
  let isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua)
  return (
    !!ua.match(/AppleWebKit.*Mobile.*/) ||
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua))
  )
}